import type { PendingEnrichment } from '@/features/catalog/types';

export interface FormattedEnrichment {
  label: string;
  title: string;
  body: string | null;
}

/** Renders a suggestion's `suggested_value` according to its target type. */
export function formatEnrichment(enrichment: PendingEnrichment): FormattedEnrichment {
  const value = enrichment.suggested_value;

  switch (enrichment.target_type) {
    case 'description':
      return { label: 'Description', title: String(value.text ?? ''), body: null };
    case 'glossary_term':
      return {
        label: 'Glossary term',
        title: String(value.term ?? ''),
        body: value.definition ? String(value.definition) : null,
      };
    case 'tag':
      return { label: 'Tag', title: String(value.tagFQN ?? ''), body: null };
    default:
      return { label: 'Suggestion', title: JSON.stringify(value), body: null };
  }
}
